import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {GroupedLessons, ScheduleTimeZone} from "features/model/types/groups/schedule/scheduleSchema";
import {fetchSchedule} from "features/model/service/groups/schedule/fetchSchedule";
import {toast} from "react-toastify";
import success = toast.success;


interface ScheduleState {
    data: GroupedLessons;
    loading: boolean;
    error: string | null;
    hasToken:boolean;
    timeZones: ScheduleTimeZone[];
}

const initialState: ScheduleState = {
    data: {},
    loading: false,
    error: null,
    hasToken:false,
    timeZones: [],
};

const scheduleSlice = createSlice({
    name: "schedule",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchSchedule.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchSchedule.fulfilled, (state, action) => {
                state.loading = false;
                state.error = null;
                state.data = action.payload.lessons;
                state.timeZones = action.payload.timeZones || [];
                state.hasToken = action.payload.hasToken
            })
            .addCase(fetchSchedule.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload as string;
            });
    },
});


export const scheduleReducer = scheduleSlice.reducer;

